import {
  BadgeProps as MantineBadgeProps,
  Badge as MantineBadge,
} from '@mantine/core';

export type BadgeProps = MantineBadgeProps;

export const Badge = MantineBadge as typeof MantineBadge;

Badge.displayName = 'Badge';
